export default __webpack_public_path__ + "static/media/desecratingessence.c843e8ee.png";